import React from "react";
import { createUseStyles } from "react-jss";
import { CDN_URL } from "Constants/CDN";
import LazyImage from "ComponentsUI/Image";

const useStyles = createUseStyles((theme) => ({
	imgMarginBottom: {
		marginBottom: "15px",
	},
	descriptionItem: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "center",
		width: "calc(50% - 13.5px)",
		fontSize: "12px",
		lineHeight: "14.4px",
		fontWeight: 300,
		textAlign: "center",
		color: theme.palette.colors.oneMoreGrey,
	},
	descriptionItem100: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",
		alignItems: "center",
		width: "100%",
		fontSize: "12px",
		lineHeight: "14.4px",
		fontWeight: 300,
		textAlign: "center",
		color: theme.palette.colors.oneMoreGrey,
	},
}));

function VariantTemplateBlock({ children, img, descriptionItemProps }) {
	const { imgMarginBottom, descriptionItem, descriptionItem100 } = useStyles();

	return (
		<li className={descriptionItemProps ? descriptionItem100 : descriptionItem}>
			<LazyImage src={`${CDN_URL}/${img}`} className={imgMarginBottom} alt={"инфографика"} />
			{children}
		</li>
	);
}

export default VariantTemplateBlock;
